<template>
  <drag-dialog
    :append-to-body="true"
    :show.sync="dialog"
    :title="isAdd ? '新增字典' : '编辑字典'"
    :enableDrag="true"
    width="500px"
    @close="cancel">
    <dynamic-form :formConfig="formConfig" v-model="form" @submit="doSubmit" @cancelForm="cancel" ref="pageForm"></dynamic-form>
  </drag-dialog>
</template>

<script>
import { add, edit } from '@/api/dict'
import DragDialog from '@/components/DragDialog'
import '@/components/dynamic-form';
export default {
  props: {
    isAdd: {
      type: Boolean,
      required: true
    }
  },
  components: {
    DragDialog
  },
  data() {
    return {
      loading: false, dialog: false,
      form: {},
      formConfig: {
        formItemList: [
            {
              type: "text",
              key: "name",
              label: "字典名称",
              placeholder: "请输入名称",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "text",
              key: "code",
              label: "字典编码",
              placeholder: "请输入字典编码",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "number",
              key: "sorting",
              label: "排序",
              value: 0,
              placeholder: "请输入排序",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "textarea",
              key: "remark",
              label: "描述",
              placeholder: "请输入描述"
            }
        ]
      }
    }
  },
  methods: {
    cancel() {
      this.resetForm()
    },
    doSubmit(val) {
      this.form = val
      if (this.isAdd) {
          this.doAdd()
      } else this.doEdit()
    },
    doAdd() {
      add(this.form).then(res => {
        this.resetForm()
        this.$notify({
          title: '添加成功',
          type: 'success',
          duration: 2500
        })
        this.loading = false
        this.$parent.dataTableInit()
      }).catch(err => {
        this.loading = false
        console.log(err.response)
      })
    },
    doEdit() {
      edit(this.form).then(res => {
        this.resetForm()
        this.$notify({
          title: '修改成功',
          type: 'success',
          duration: 2500
        })
        this.loading = false
        this.$parent.dataTableInit()
      }).catch(err => {
        this.loading = false
        console.log(err.response.data.message)
      })
    },
    resetForm() {
      this.dialog = false
      this.$refs.pageForm.resetForm()
    }
  }
}
</script>

<style scoped>

</style>
